import Image from 'components/LegacyImage'
import { ArticleItem } from 'types/data'

interface AsideListItemProps {
  item: ArticleItem
}

export const AsideListItem = ({ item }: AsideListItemProps) => (
  <>
    <div className='mc-mr-4'>
      <h3 className='mc-text-h7 mc-text--capitalize'>{item.title}</h3>
      {item.subtitle && (
        <p className='mc-opacity--muted mc-text-x-small mc-text--light mc-text--capitalize mc-text--pre-wrap'>
          {item.subtitle}
        </p>
      )}
    </div>
    <div className='flex-shrink-0 d-flex'>
      {item.subtitle ? (
        <Image
          alt=''
          className='mc-corners--circle'
          height={64}
          src={item.image}
          width={64}
        />
      ) : (
        <Image alt='' src={item.image} height={40} width={70} />
      )}
    </div>
  </>
)
